import { jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { useLocale } from '../../i18n/locale-context.js';
import { cn } from '../../lib/cn.js';
export function Footer({ systemName, ministryName, buildId, className }) {
    const { t } = useLocale();
    const year = new Date().getFullYear();
    const identityLine = ministryName ? `${t('govIdentity.label')} — ${ministryName}` : t('govIdentity.label');
    return (_jsxs("footer", { role: "contentinfo", className: cn('flex flex-wrap items-center justify-between gap-x-4 gap-y-1 border-t border-border-decorative px-6 py-3 text-xs text-text-muted', className), children: [_jsxs("p", { children: [identityLine, " \u00B7 ", systemName] }), _jsxs("p", { children: [buildId ? _jsxs(_Fragment, { children: [t('footer.build', { buildId }), " \u00B7 "] }) : null, t('footer.copyright', { year })] })] }));
}
//# sourceMappingURL=Footer.js.map